import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';
import { authApi, ApiError } from '../api/client';

export function RegisterPage() {
    const navigate = useNavigate();
    const { setUser } = useAuthStore();

    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setError('两次输入的密码不一致');
            return;
        }

        if (password.length < 8) {
            setError('密码长度至少为 8 个字符');
            return;
        }

        setLoading(true);

        try {
            const { user, sessionId } = await authApi.register(username, email, password);
            setUser(user, sessionId);
            navigate('/dashboard');
        } catch (err) {
            if (err instanceof ApiError) {
                setError(err.message);
            } else {
                setError('注册失败，请重试');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h2 className="text-center mb-lg" style={{ fontSize: 'var(--font-size-xl)', fontWeight: 'var(--font-weight-semibold)' }}>
                创建 GitCenter 账户
            </h2>

            <form onSubmit={handleSubmit}>
                {error && (
                    <div className="mb-md" style={{
                        padding: 'var(--spacing-sm) var(--spacing-md)',
                        backgroundColor: 'rgba(248, 81, 73, 0.1)',
                        border: '1px solid var(--color-danger)',
                        borderRadius: 'var(--radius-md)',
                        color: 'var(--color-danger)',
                        fontSize: 'var(--font-size-sm)'
                    }}>
                        {error}
                    </div>
                )}

                <div className="form-group">
                    <label className="form-label" htmlFor="username">
                        用户名
                    </label>
                    <input
                        id="username"
                        type="text"
                        className="form-input"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        pattern="[a-zA-Z0-9][a-zA-Z0-9-]{1,38}[a-zA-Z0-9]"
                        title="2-39 个字符，只能包含字母、数字和连字符"
                        autoComplete="username"
                        autoFocus
                    />
                </div>

                <div className="form-group">
                    <label className="form-label" htmlFor="email">
                        邮箱
                    </label>
                    <input
                        id="email"
                        type="email"
                        className="form-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        autoComplete="email"
                    />
                </div>

                <div className="form-group">
                    <label className="form-label" htmlFor="password">
                        密码
                    </label>
                    <input
                        id="password"
                        type="password"
                        className="form-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        minLength={8}
                        autoComplete="new-password"
                    />
                </div>

                <div className="form-group">
                    <label className="form-label" htmlFor="confirmPassword">
                        确认密码
                    </label>
                    <input
                        id="confirmPassword"
                        type="password"
                        className="form-input"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        autoComplete="new-password"
                    />
                </div>

                <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ width: '100%', marginTop: 'var(--spacing-md)' }}
                    disabled={loading}
                >
                    {loading ? '注册中...' : '注册'}
                </button>
            </form>

            <p className="text-center mt-lg text-muted" style={{ fontSize: 'var(--font-size-sm)' }}>
                已有账户？{' '}
                <Link to="/login">立即登录</Link>
            </p>
        </div>
    );
}
